import React from 'react'
import { Link } from 'react-router-dom'
import { Cpu, Mail, Phone, MapPin, ExternalLink } from 'lucide-react'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'Products', href: '/products' },
    { name: 'Manufacturing', href: '/manufacturing' },
    { name: 'Contact', href: '/contact' },
  ]

  const services = [
    'AI Chip Development',
    'Contract Manufacturing',
    'Technology Consulting',
    'Custom Solutions',
  ]

  return (
    <footer className="bg-secondary-900 text-white">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-4 group">
              <div className="flex-shrink-0">
                <img
                  src="/SATMERC Logo.png"
                  alt="SATMERC Tech Logo"
                  className="h-24 w-auto object-contain brightness-0 invert"
                />
              </div>
              <div className="flex flex-col">
                <span className="text-2xl font-bold">SATMERC TECH</span>
                <span className="text-xs text-secondary-400 mt-1">Powered by DKG & NPJ</span>
              </div>
            </Link>
            <p className="text-secondary-300 text-sm leading-relaxed">
              Shaping the Future of Artificial Intelligence with Next-Generation Semiconductor Chips.
              Leading innovation in AI chip technology and manufacturing.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-secondary-300 hover:text-white transition-colors text-sm flex items-center group"
                  >
                    <span>{link.name}</span>
                    <ExternalLink className="h-3 w-3 ml-1 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service} className="text-secondary-300 text-sm">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="h-4 w-4 text-primary-400 mt-1 flex-shrink-0" />
                <p className="text-secondary-300 text-sm">
                  Corporate Park, D 21, Sector 21,<br />
                  Shahabad Mohammadpur,<br />
                  New Delhi, Delhi 110077
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-4 w-4 text-primary-400 flex-shrink-0" />
                <a
                  href="tel:+919810124321"
                  className="text-secondary-300 hover:text-white transition-colors text-sm"
                >
                  +91-98101 24321
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-4 w-4 text-primary-400 flex-shrink-0" />
                <a
                  href="mailto:mdoffice@dkgrouplabs.com"
                  className="text-secondary-300 hover:text-white transition-colors text-sm"
                >
                  mdoffice@dkgrouplabs.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-secondary-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-secondary-400 text-sm">
              © {currentYear} SATMERC TECH. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-secondary-400 hover:text-white transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-secondary-400 hover:text-white transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-secondary-400 hover:text-white transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
